import styles from 'components/shared/LoadingSpinner.module.css'

import type { ReactElement } from 'react'

interface LoadingSpinnerProperties {
  message?: string
}

export const LoadingSpinner = ({ message = 'Loading...' }: LoadingSpinnerProperties): ReactElement => {
  /* --- Section 6: Render --- */
  return (
    <div className={styles.container}>
      <div className={styles.spinner} />
      <p className={styles.message}>{message}</p>
    </div>
  )
}
